import React from 'react';
import CookieAnalytics from './cookie-analytics';
import PageAnalytics from './page-analytics';
import PageviewsAndTimeAnalytics from './pageviews-and-time-analytics';
import VideoAnalytics from './video-analytics';

const Analytics = () => (
  <>
    <PageAnalytics />
    <PageviewsAndTimeAnalytics />
    <VideoAnalytics />
    <CookieAnalytics/>
  </>
);

export default Analytics;
